import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=58d1c3e8&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d1c3e8')) {
      api.createRecord('58d1c3e8', component.options)
    } else {
      api.reload('58d1c3e8', component.options)
    }
    module.hot.accept("./Incident.vue?vue&type=template&id=58d1c3e8&", function () {
      api.rerender('58d1c3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Incident.vue"
export default component.exports